var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.sortOrder),function(sortItem){return _vm._t("default",function(){return [_c('SortedProductList',{attrs:{"category-id":_vm.categoryId,"sort-order":sortItem}})]})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }